/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GeocodeUnitRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GeocodeUnitResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const geocodeUnit = (request: GeocodeUnitRequest, options?: CashRequestOptions) => post<GeocodeUnitRequest, GeocodeUnitResponse>("/2.0/cash/geocode-unit", request, {...options, rejectOnError: true })